import { __assign } from "tslib";
// @ts-nocheck
import './ListLinks.css';
import React from 'react';
import { IconArrowRight } from '../../icons/IconArrowRight/IconArrowRight';
import { IconOpenInNew } from '../../icons/IconOpenInNew/IconOpenInNew';
import { cn } from '../../utils/bem';
import { Button } from '../Button/Button';
var cnListLinks = cn('ListLinks');
export var ListLinks = function (props) {
    var items = props.items, getLabel = props.getLabel, getPath = props.getPath, onLinkClick = props.onLinkClick;
    var linkAttrs = function (item) {
        var pathLink = getPath === null || getPath === void 0 ? void 0 : getPath(item);
        var targetBlank = item.targetBlank, labelColor = item.labelColor, labelText = item.labelText, hideLabel = item.hideLabel, label = item.label;
        if (pathLink && !pathLink.includes('http') && !targetBlank) {
            return __assign({ isLink: true, to: pathLink, iconRight: IconArrowRight }, (label && label.value && {
                badge: {
                    text: label.value,
                    inverted: !!label.isInverted,
                    color: label.labelColor
                }
            }));
        }
        if (pathLink && !targetBlank) {
            return __assign({ as: 'a', href: pathLink, iconRight: IconOpenInNew, target: '_self', size: 's' }, (label && label.value && {
                badge: {
                    text: label.value,
                    inverted: !!label.isInverted,
                    color: label.labelColor
                }
            }));
        }
        if (pathLink && targetBlank) {
            return __assign({ as: 'a', href: pathLink, iconRight: IconOpenInNew, target: '_blank', size: 's' }, (label && label.value && {
                badge: {
                    text: label.value,
                    inverted: !!label.isInverted,
                    color: label.labelColor
                }
            }));
        }
        if (!hideLabel && labelText) {
            return {
                badge: {
                    text: labelText,
                    color: labelColor
                },
                align: 'between',
                disabled: true
            };
        }
        return {
            disabled: true
        };
    };
    return (React.createElement("div", { className: cnListLinks() }, items.map(function (item) {
        var label = getLabel(item);
        return (React.createElement("div", { className: cnListLinks('Item'), key: item.id },
            React.createElement(Button, __assign({ view: 'link-primary', label: label, width: 'full' }, linkAttrs(item), { onClick: onLinkClick ? function () { return onLinkClick(label); } : undefined }))));
    })));
};
